export const exceptionTypes = Object.freeze({
  EmailExistsException: 'This email already exists',

  NotAuthorizedException: 'Incorrect password',
});

export const RESOURCES = Object.freeze({
  CAD: 'CAD',
  CADDESIGN: 'CADDESIGN',
  SEGMENTATION: 'SEGMENTATION',
  PLANNER: 'PLANNER',
  LAUNCHER: 'LAUNCHER',
  SCANNER: 'SCANNER',
  CASECLOUD: 'CASECLOUD',
});
